
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wholesale-parts-hub/certified-collision",
      function () {
        return require("private-next-pages/wholesale-parts-hub/certified-collision.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wholesale-parts-hub/certified-collision"])
      });
    }
  